import { render, staticRenderFns } from "./tag-edit.vue?vue&type=template&id=56698d7a&scoped=true&"
import script from "./tag-edit.vue?vue&type=script&lang=ts&"
export * from "./tag-edit.vue?vue&type=script&lang=ts&"
import style0 from "./tag-edit.vue?vue&type=style&index=0&id=56698d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56698d7a",
  null
  
)

export default component.exports